export default "__VITE_ASSET__df41dc76__"